export default "__VITE_ASSET__DXnp0aHI__";